var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
//components
import { Typography, makeStyles, createStyles } from "@material-ui/core";
export default React.forwardRef((_a, ref) => {
    var { variant, component = "span", color, className = "" } = _a, otherProps = __rest(_a, ["variant", "component", "color", "className"]);
    const classes = useStyles({ color, variant });
    return (React.createElement(Typography, Object.assign({ ref: ref, component: component, className: classes.typography + " " + className }, otherProps)));
});
const useStyles = makeStyles((theme) => createStyles({
    typography: ({ color = "primary", variant = "p3", }) => (Object.assign(Object.assign({}, theme.typography[variant]), { color: color !== "inherit" ? theme.palette.text[color] : "inherit" })),
}));
//# sourceMappingURL=FTLTypography.js.map